export default __webpack_public_path__ + "static/media/disney_bingo.6ee407be.png";